// @flow
import { DURATION, EASING, OPACITY_LEVEL, TRANSITION_DEF } from '../constants';
import styled, { keyframes } from 'styled-components';

const revealOpacity = keyframes`to { opacity: 1; }`;

export const Container = styled.g`cursor: ${p => (p.isCopyMode ? 'pointer' : 'inherit')};`;

export const ClickableArea = styled.rect`fill: transparent;`;

export const EventsContainer = styled.g`
    opacity: ${p => (p.blur ? 0.3 : 1)};
    transition: ${TRANSITION_DEF};
`;

export const Mask = styled.rect`
    fill: white;
    transition: ${TRANSITION_DEF};
`;

export const TextContainer = styled.g`
    animation: ${revealOpacity} ${DURATION} ${EASING} forwards;
    animation-delay: ${DURATION};
    cursor: pointer;
    opacity: 0;
    transition: ${TRANSITION_DEF};
`;

export const DayLabel = styled.text`
    opacity: ${p => (p.blurLabel ? OPACITY_LEVEL : 1)};
    text-anchor: middle;
`;

export const CopyButtonContainer = styled.g`transition: ${TRANSITION_DEF};`;

export const CopyButton = styled.circle`
	fill: ${p => (p.isSelectedToBeCopied ? p.theme.mainBrandColor : p.theme.white)}
	stroke: ${p => (p.isCopiedTo ? p.theme.white : p.theme.mainBrandColor)}
`;

export const Line = styled.line`
    stroke: ${p => (p.isCopiedTo ? p.theme.mainBrandColor : p.theme.white)};
    stroke-width: 2;
`;

export const CloseGroup = styled.g`
    animation: ${revealOpacity} ${DURATION} ${EASING} forwards;
    animation-delay: ${DURATION};
    cursor: pointer;
    opacity: 0;
`;

export const CloseBorder = styled.rect`
    fill: ${p => p.theme.white};
    stroke: ${p => p.theme.footerColor};
    stroke-width: 1;
`;

export const CloseText = styled.text`fill: ${p => p.theme.mainBrandColor};`;

export const CrossPath = styled.path`
    stroke: ${p => p.theme.heavyGrey};
    stroke-width: 2px;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/day/style.js